import React from 'react';
const steps = ['Open it.', 'Choose it.', 'Adapt it.', 'Coach it.'];
const negatives = ['No complicated method.', 'No endless searching.', 'No rebuilding from scratch.'];
export function SolutionSection() {
  return <section className="bg-petrol text-white px-4 sm:px-6 py-9 sm:py-12" data-id="element-151" data-mp="3oa3hjlnr2n55">
      <div className="max-w-3xl mx-auto text-center" data-id="element-152" data-mp="3j9xwwpfwe0wk">
        <p className="font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.18em] text-gold mb-2.5" data-id="element-153" data-mp="3jcaakqemhp3t">
          Meet Fitness Senior Ready™
        </p>

        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight mb-3.5" data-id="element-154" data-mp="3t7lqhc1rp2d5">
          A ready-to-use coaching system built specifically for{' '}
          <span className="text-lime" data-id="element-155" data-mp="5wch2vile11a">older adult fitness.</span>
        </h2>

        <p className="text-[13px] sm:text-base text-white/75 leading-relaxed max-w-xl mx-auto mb-6" data-id="element-156" data-mp="ks24my3fem84">
          Instead of searching, collecting, and organizing everything yourself,
          you have one structured place to find the exercises, sessions,
          progressions, programs, and professional tools you need.
        </p>

        <ol className="grid grid-cols-4 gap-2 mb-6" data-id="element-157" data-mp="3ba8p4i2f7inb">
          {steps.map((step, i) => <li key={step} className="bg-white/[0.06] border border-white/10 rounded-lg px-2 py-3" data-id="element-158" data-mp="3faivvwy1ed38" data-mpi={i}>
              <span className="block font-heading font-black text-lime text-base leading-none mb-1" data-id="element-159" data-mp="3k80x115tbo0o">
                {i + 1}
              </span>
              <span className="font-heading font-bold uppercase text-[9px] sm:text-xs tracking-wide leading-snug" data-id="element-160" data-mp="3u7jd36ilqpng">
                {step}
              </span>
            </li>)}
        </ol>

        <ul className="flex flex-col sm:flex-row justify-center gap-1 sm:gap-6" data-id="element-161" data-mp="6ufn1nv6uidb">
          {negatives.map(item => <li key={item} className="text-[11px] sm:text-sm font-semibold text-white/60" data-id="element-162" data-mp="bw4wiz2rinza">
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}